import React from "react"
import { NextSeo } from "next-seo"
import styled from "styled-components"
import Header from "~/components/dashboard/Layout/Header/OldAppHeader"
import WinItButton from "~/components/WinItButton"
import Footer from "~/components/Footer"
import Center from "~/components/basic/Center"
import Spacer from "~/components/Spacer"
import {
  SUPPORT_PHONE_NUMBER,
  SUPPORT_PHONE_NUMBER_WL,
} from "~/components/altHeaders/phoneNumbers"
import useInject from "~/hooks/useInject"

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2em;
  width: 100%;
  background-color: #fbfcfd;
  @media (max-width: 650px) {
    background-color: white;
  }
`

const StyledLink = styled.a`
  display: inline-block;
  color: rgba(48, 137, 243, 1);
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

const mapStore = (store) => ({
  storedTrafficStateName: store.trafficLookup.fetcherName,
  isStateAffiliatedWithWinitLaw:
    store.trafficLookup.isStateAffiliatedWithWinitLaw,
})

const Contact = () => {
  const { isStateAffiliatedWithWinitLaw } = useInject(mapStore)
  return (
    <>
      {isStateAffiliatedWithWinitLaw ? (
        <NextSeo
          title="Contact WinIt Law"
          description="Reach out to the WinIt Law team for support or inquiries. Contact us by email or phone."
          canonical="https://www.winitlaw.com/contact"
        />
      ) : (
        <NextSeo
          title="Contact WinIt"
          description="Reach out to the WinIt team for support or inquiries. We're here to help with your parking and traffic ticket disputes."
          canonical="https://www.appwinit.com/contact"
          additionalMetaTags={[
            {
              name: "description",
              content:
                "Reach out to the WinIt team for support or inquiries. We're here to help with your parking and traffic ticket disputes.",
            },
          ]}
        />
      )}
      <Header />
      <ButtonContainer>
        <Center>
          {isStateAffiliatedWithWinitLaw ? (
            <h1>WinIt Law Customer Support</h1>
          ) : (
            <h1>WinIt Customer Support</h1>
          )}
          <p>
            You can contact us by email and we&apos;ll get back to you as soon
            as we can.
          </p>
          <p>
            Our email address is:&nbsp;
            {isStateAffiliatedWithWinitLaw ? (
              <StyledLink href="mailto:support@winitlaw.com">
                support@winitlaw.com
              </StyledLink>
            ) : (
              <StyledLink href="mailto:support@appwinit.com">
                support@appwinit.com
              </StyledLink>
            )}
          </p>
          <p>
            Phone Number:&nbsp;
            {isStateAffiliatedWithWinitLaw ? (
              <>
                <StyledLink href={`tel:${SUPPORT_PHONE_NUMBER_WL.number}`}>
                  {SUPPORT_PHONE_NUMBER_WL.displayNumber}
                </StyledLink>
                &nbsp;({SUPPORT_PHONE_NUMBER_WL.rawDisplayNumber})
              </>
            ) : (
              <>
                <StyledLink href={`tel:${SUPPORT_PHONE_NUMBER.number}`}>
                  {SUPPORT_PHONE_NUMBER.displayNumber}
                </StyledLink>
                &nbsp;({SUPPORT_PHONE_NUMBER.rawDisplayNumber})
              </>
            )}
          </p>
        </Center>
        <br />
        <Spacer mobile={30} desktop={30} />
        <WinItButton
          as="button"
          type="button"
          color="green"
          width="200px"
          height={70}
          fontSize="1em"
          onClick={() => {
            window.location = isStateAffiliatedWithWinitLaw
              ? "mailto:support@winitlaw.com"
              : "mailto:support@appwinit.com"
          }}
        >
          Email Support
        </WinItButton>
      </ButtonContainer>
      <Footer
        noMedia
        noDisclaimer
        isStateAffiliatedWithWinitLaw={isStateAffiliatedWithWinitLaw}
      />
    </>
  )
}

export default Contact
